import { Grid, keyframes, Box } from "@mui/material";
import { styled } from "@mui/material";
import React from "react";
import TransitionComponent from "./TransitionComponent";
import BlurredProgressiveImage from "./BlurredProgressiveImage";
import { getLogoAttributes } from "../config/logos";

const rollInLeft = keyframes`
  0% {
    left: 0%;
  }
  100% {
    left: -100%;
  }

`;
const Roller = styled(Grid)(({ roll }) => ({
  position: "relative",
  height: "130px",
  margin: 0,
  padding: 0,
  backgroundColor: "#000000",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  visibility: !roll && "hidden",
  animation: roll && `${rollInLeft} 12s infinite linear`,
  zIndex: 10000,
}));

export function InfiniteRollingLogos(props) {
  // Get logo attributes from shared config
  const logoImgAttributes = getLogoAttributes().map((attrs) => ({
    ...attrs,
    style: {
      margin: "auto",
    },
  }));
  const logoImgs = [
    logoImgAttributes.map((attributes) => (
      <BlurredProgressiveImage
        key={`${attributes.key}_0`}
        src={attributes.src}
        placeholder={attributes.placeholder}
        blurAmount={2}
        transitionDuration="1s"
        alt={attributes.alt}
        height={attributes.height}
        style={attributes.style}
        fetchPriority="high"
        loading="eager"
      />
    )),
    logoImgAttributes.map((attributes) => (
      <BlurredProgressiveImage
        key={`${attributes.key}_1`}
        src={attributes.src}
        placeholder={attributes.placeholder}
        blurAmount={2}
        transitionDuration="1s"
        alt={attributes.alt}
        height={attributes.height}
        style={attributes.style}
        fetchPriority="high"
        loading="eager"
      />
    )),
  ];
  return (
    <Box
      sx={{
        transition: "opacity 0.1s ease-out .1s",
        mt: props.mt ? props.mt : 0,
        mb: props.mb ? props.mb : 0,
        backgroundColor: "#050505",
        width: "100vw",
        zIndex: 500000,
      }}
    >
      {!props.noslide ? (
        <TransitionComponent>
          <Roller
            roll="true"
            overflow="hidden"
            container
            direction="row"
            spacing={5}
            style={{ width: "200vw" }}
            sx={{
              height: { xs: 40, sm: 50, md: 90, lg: 110, xl: 130 },
            }}
          >
            {logoImgs}
          </Roller>
        </TransitionComponent>
      ) : (
        <Box>
          <Roller
            roll="true"
            overflow="hidden"
            container
            direction="row"
            spacing={5}
            style={{ width: "200vw" }}
            sx={{
              height: { xs: 40, sm: 50, md: 90, lg: 110, xl: 130 },
              alignItems: "center",
            }}
          >
            {logoImgs}
          </Roller>
        </Box>
      )}
    </Box>
  );
}
